import { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

// search
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Col from "react-bootstrap/esm/Col";
import Form from "react-bootstrap/esm/Form";
import InputGroup from "react-bootstrap/esm/InputGroup";
import { ROUTES } from "../../../utils/routes";
import Axios from "axios";
import { getAll } from "../../../utils/requests/dynamicReq";
import { INews } from "../../../interfaces/INews";
import { paths } from "../../../utils/paths";
import * as XLSX from "xlsx";

export const News: FC = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { COMMUNICATIONS } = paths;
  const [news, setNews] = useState<INews[]>([]);
  const [displayNews, setDisplayNews] = useState<INews[]>([]);

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    loadData();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);

  const loadData = async () => {
    try {
      const response = await getAll(COMMUNICATIONS, source);
      if (isMountedRef.current) {
        setNews(response);
        setDisplayNews(response);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("HTTP call cancelled");
    }
  };

  const searchBar = (value: any) => {
    const filtered = news.filter(({ titleEs }) =>
      titleEs?.toLowerCase().includes(value.toLowerCase())
    );
    setDisplayNews(value ? filtered : news);
  };

  const handleExportToExcel = () => {
    if (!news) return;

    const dataToExport = news.map((n) => ({
      ID: n.id,
      "Título (ES)": n.titleEs,
      "Título (EN)": n.titleEn,
      "Título (VA)": n.titleVa,
      "Subtítulo (ES)": n.subtitleEs,
      "Subtítulo (EN)": n.subtitleEn,
      "Subtítulo (VA)": n.subtitleVa,
      "Texto (ES)": n.textEs,
      "Texto (EN)": n.textEn,
      "Texto (VA)": n.textVa,
      FechaInicio: n.fechaInicio,
      FechaFin: n.fechaFin,
      FechaHora: n.fechaHora,      
      ApareceActualidad: n.aparecerActualidad ? "Sí" : "No",     
      URL: n.url || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Noticias");

    XLSX.writeFile(workbook, "noticias.xlsx");
  };

  return (
    <div className="container-fluid p-4">
      <div className="row">
        <div className="col d-flex justify-content-between">
          <div>
            <h3>Noticias</h3>
          </div>
          <div className="d-flex gap-2">
            <button
              className="baseBtn"
              onClick={() => history.push(ROUTES.News.create)}
            >
              + Añadir
            </button>
            <button className="baseBtn" onClick={handleExportToExcel}>
              Descargar Excel
            </button>
          </div>
        </div>
      </div>
      <div className="row mt-4">
        <Form.Group as={Col}>
          <InputGroup className="shadow">
            <InputGroup.Prepend>
              <InputGroup.Text className="inputGroup ">
                <FontAwesomeIcon color="#0073B5" icon={faSearch} />
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              type="text"
              placeholder="Buscar..."
              className="form-control"
              onChange={({ target: { value } }) => searchBar(value)}
            />
          </InputGroup>
        </Form.Group>
      </div>
      <div className="row">
        <div className="col-12 ">
          <table className="table table-hover">
            <tbody>
              {displayNews?.map(({ id, titleEs }) => (
                <tr
                  key={id}
                  className="pointer"
                  onClick={() => history.push(`${ROUTES.News.all}/${id}`)}
                >
                  <td>{titleEs}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {isLoading && (
            <div className="d-flex justify-content-center">
              <div className="spinner-border mt-5" role="status" />
            </div>
          )}
          {!news.length && !isLoading && (
            <div className="d-flex justify-content-center mb-3">
              <h5>-No existen noticias-</h5>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
